import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem } from 'polished'

import { RADIUS_1 } from '@Styles/constants/radius'

export const WIDGET_CLASS_NAME = 'zou_odsearch_widget_app'

export const global = css([
  {
    // Prevent styles to avoid conflicts with the host page
    ':host': {
      all: 'initial',
      position: 'relative',
    },
  },
  {
    div: {
      boxSizing: 'border-box',
    },
  },
  {
    '*': {
      boxSizing: 'inherit',
    },
    '*::after': {
      boxSizing: 'inherit',
    },
    '*::before': {
      boxSizing: 'inherit',
    },
  },
  {
    [`.${WIDGET_CLASS_NAME}`]: {
      MozOsxFontSmoothing: 'grayscale',
      WebkitFontSmoothing: 'antialiased',
    },
  },
])

export const widgetContainer = (theme: Theme): SerializedStyles =>
  css({
    background: theme.customPalette.background.default,
    borderRadius: RADIUS_1,
    margin: '0 auto',
    maxWidth: rem(1000),
    minWidth: rem(300),
  })

export const widgetTitle = (theme: Theme): SerializedStyles =>
  css({
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      marginBottom: theme.spacing(3),
    },
  })

export const widgetContent = (theme: Theme): SerializedStyles => {
  const borders = `1px solid ${theme.customPalette.onElements.outline}`

  return css({
    borderBottom: borders,
    borderLeft: borders,
    borderRadius: `0 0 ${RADIUS_1} ${RADIUS_1}`,
    borderRight: borders,
    padding: theme.spacing(3, 2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4),
    },
  })
}
